import SurveyStepActionsKpiTabContainer from "./SurveyStepActionsKpiTabContainer";
export default SurveyStepActionsKpiTabContainer;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTab/index.js